import script from "./AddVariantProductToPropertyValue.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddVariantProductToPropertyValue.vue?vue&type=script&setup=true&lang=ts"

import "./AddVariantProductToPropertyValue.vue?vue&type=style&index=0&id=86c1ee30&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86c1ee30"]])

export default __exports__